import { render } from "./WidgetSettings.vue?vue&type=template&id=4e64a67c&ts=true"
import script from "./WidgetSettings.vue?vue&type=script&lang=ts"
export * from "./WidgetSettings.vue?vue&type=script&lang=ts"

import "./WidgetSettings.vue?vue&type=style&index=0&id=4e64a67c&lang=scss"

import exportComponent from "D:\\DEV\\Projects\\weather-widget\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__